<template>
  <Modal
    cancel-variant="filled"
    :close-triggers="['click-outside', 'close-button', 'escape']"
    data-testid="editor-delete-all-plays-modal"
    spacing="medium"
    :tracking="{
      action: 'checkout',
      topicKey: 'delete_all_plays_confirmation',
    }"
    @cancel="emit('cancel')"
    @confirm="emit('confirm')"
  >
    <template #headline>
      <span class="flex text-left">
        {{ $t('lottery.selectednumbers.deleteall.modal.headline') }}
      </span>
    </template>

    <template #confirm>
      {{ $t('lottery.selectednumbers.deleteall.modal.confirm') }}
    </template>

    <p class="paragraph-regular text-left w-full">
      {{ $t('lottery.selectednumbers.deleteall.modal.message') }}
    </p>

    <Illustration class="mt-200" name="delete-all-lines" />
  </Modal>
</template>

<script lang="ts" setup>
type Emits = {
  (e: 'cancel' | 'confirm'): void
}

const emit = defineEmits<Emits>()
</script>
